/* tslint:disable */

export enum LinkElementType {
  Text = 1,
  FlowchartNode = 4,
  External = 5,
  Compendium = 6,
  Guideline = 7,
  Widget = 8,
}
